import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import _ from 'lodash';
import { useConfig } from '@lore/config';
import queryString from 'query-string';
import Overlay from '@/forms/_common/Overlay';
import FormErrors from '@/forms/_common/FormErrors';
import RequestError from '@/forms/_common/RequestError';
import ErrorMessage from '@/forms/_common/ErrorMessage';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import FormTemplate from '@/dialogs_common/FormTemplate';
import FormField from '@/forms/_common/FormField';
import TextAreaField from '@/forms/_fields_v2/TextAreaField';
import SolidButton from '@/components/Button/SolidButton';
import { PayloadStates } from '@lore/utils';
import { TrashIcon } from '@heroicons/react/24/outline';

Info.propTypes = {
  user: PropTypes.shape({
    data: PropTypes.shape({
      email: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  data: PropTypes.shape({
    question1: PropTypes.string
  }).isRequired,
  onNext: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default function Info(props) {
  const {
    user,
    data: propsData,
    onNext,
    onCancel
  } = props;

  const [data, setData] = useState(_.pick(propsData, [
    'question1'
  ]));
  const [showErrors, setShowErrors] = useState(false);
  const [_request, setRequest] = useState(null);
  const [finished, setFinished] = useState(false);

  const request = _request;
  const saving = request && request.state === PayloadStates.CREATING;
  const error = request && request.state === PayloadStates.ERROR_CREATING;
  const success = request && request.state === PayloadStates.RESOLVED;

  const config = useConfig();

  useEffect(() => {
    if (success && !finished) {
      setFinished(true);
      onNext(data);
    }
  });

  const questions = [
    `Would you share the reason you're deleting your account? Is there something we can improve?`
  ];

  function onSubmit() {
    axios({
      url: config.intercom.messengerUrl,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: queryString.stringify({
        app_id: config.intercom.appId,
        user_data: JSON.stringify({
          email: user.data.email
        }),
        blocks: JSON.stringify([
          {
            type: "paragraph",
            text: `I would like to delete my account.`
          },
          {
            type: "paragraph",
            text: `Q: ${questions[0]}`
          },
          {
            type: "paragraph",
            text: `A: ${data.question1}`
          }
        ])
      })
    }).then(function() {
      setRequest({
        state: PayloadStates.RESOLVED
      });
    }).catch(function(error) {
      setRequest({
        state: PayloadStates.ERROR_CREATING,
        error: error
      });
    });

    setRequest({
      state: PayloadStates.CREATING
    });
  }

  function onChange(name, value) {
    setData(_.merge({}, data, {
      [name]: value
    }));
  }

  return (
    <DialogTemplate>
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          // question1: [validators.isRequired]
        }}>
          {({ errors, hasError }) => {
            return (
              <FormTemplate
                icon={(
                  <div className="flex justify-center mb-4">
                    <TrashIcon className="text-cs-orange-500 h-12 w-12" />
                  </div>
                )}
                title="Delete Account"
                subtitle="Are you sure you want to delete your account? This action is irreversible and can not be undone."
                onClose={onCancel}
                alert={error ? (
                  <RequestError request={request} />
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : null}
                body={(
                  <>
                    <FormField name="question1" data={data} errors={showErrors && errors} onChange={onChange}>
                      {(field) => (
                        <TextAreaField
                          label={`${questions[0]}`}
                          placeholder="Reason or suggestion..."
                          rows={3}
                          value={field.value}
                          error={field.error}
                          onChange={field.onChange}
                        />
                      )}
                    </FormField>
                  </>
                )}
                footer={(
                  <>
                    <SolidButton onClick={() => hasError ? setShowErrors(true) : onSubmit()}>
                      Delete my account
                    </SolidButton>
                  </>
                )}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
